import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/products.css"
import "../style/projects.css"

function Projects() {
  const data = useStaticQuery(graphql`
    query {
      derekjsmith: file(relativePath: { eq: "derekjsmith.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Special Projects</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <Row>
          <Col xs="12">
            <h1>Special Projects</h1>
          </Col>
          <Col xs="12">
            <h2>Derek J. Smith</h2>
            <h5>
              CEng (Information Systems), CITP, FHEA, MBCS, Dip Med Ed (Dundee)
            </h5>
          </Col>
          <Col xs="12" sm="4">
            <Img
              className="derek"
              fluid={data.derekjsmith.childImageSharp.fluid}
              alt="Derek J Smith"
            />
          </Col>
          <Col xs="12" sm="8">
            <h4>KONRAD</h4>
            <p>
              Konrad is a mainframe software product modelling the end-to-end
              flow of biological cognition, but with a special focus on the
              semantic network nature of the mind's long-term memory systems. It
              has been designed to offer clients a simulation test-bed, complete
              with detailed print-out, on which th`ey can test hypotheses as to
              mental function which could not be tested in living subjects
            </p>
            <h4>About Derek J Smith</h4>
            <p>
              Between 1980 and 1991 Derek worked for the data processing arm of
              British Telecom, specialising in the design and operation of very
              large databases and management support systems. Between 1991 and
              2010 he lectured in cognitive science at the University of Wales
              Institute, Cardiff (UWIC), specialising in the cognitive
              neuropsychology of human communication. His research interests
              include the nature of biological memory mechanisms, the evolution
              of the mind, Heideggerian Dasein as a problem for semantic network
              designers, and the use of computer animation and Internet
              technology as teaching resources. His consultancy specialisms
              include IT project assurance, business analysis and modelling, and
              the design of high-impact learning experiences in both academic
              and organisational settings. He is also the Chief Designer on the
              Konrad artificial consciousness project and the founder of the
              Smithsrisca brand of academic e-content.
            </p>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Projects
